import { render, staticRenderFns } from "./my_coll_news.vue?vue&type=template&id=7c46ba4b&scoped=true"
import script from "./my_coll_news.vue?vue&type=script&lang=js"
export * from "./my_coll_news.vue?vue&type=script&lang=js"
import style0 from "./my_coll_news.vue?vue&type=style&index=0&id=7c46ba4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c46ba4b",
  null
  
)

export default component.exports